// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Graph Engine API
 * HTTP API for managing Neo4j graph engines.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HandlersPatchGraphEngineInternalRequest
 */
export interface HandlersPatchGraphEngineInternalRequest {
  /**
   *
   * @type {string}
   * @memberof HandlersPatchGraphEngineInternalRequest
   */
  memory?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersPatchGraphEngineInternalRequest
   */
  neo4jVersion?: string;
}

/**
 * Check if a given object implements the HandlersPatchGraphEngineInternalRequest interface.
 */
export function instanceOfHandlersPatchGraphEngineInternalRequest(
  value: object,
): value is HandlersPatchGraphEngineInternalRequest {
  return true;
}

export function HandlersPatchGraphEngineInternalRequestFromJSON(
  json: any,
): HandlersPatchGraphEngineInternalRequest {
  return HandlersPatchGraphEngineInternalRequestFromJSONTyped(json, false);
}

export function HandlersPatchGraphEngineInternalRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersPatchGraphEngineInternalRequest {
  if (json == null) {
    return json;
  }
  return {
    memory: json['memory'] == null ? undefined : json['memory'],
    neo4jVersion:
      json['neo4jVersion'] == null ? undefined : json['neo4jVersion'],
  };
}

export function HandlersPatchGraphEngineInternalRequestToJSON(
  json: any,
): HandlersPatchGraphEngineInternalRequest {
  return HandlersPatchGraphEngineInternalRequestToJSONTyped(json, false);
}

export function HandlersPatchGraphEngineInternalRequestToJSONTyped(
  value?: HandlersPatchGraphEngineInternalRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    memory: value['memory'],
    neo4jVersion: value['neo4jVersion'],
  };
}
